import React from 'react';
import { Avatar, Box, List, ListItemButton, Skeleton, Stack, Typography } from '@mui/material';
import { formatWhen, senderInitial, senderName } from './emailUtils';

export default function EmailMessageList({ messages, selectedId, loading, onSelect }) {
  if (loading && !messages.length) {
    return (
      <Stack spacing={1.25} sx={{ p: 1.5 }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" height={72} />
        ))}
      </Stack>
    );
  }

  if (!messages.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2.5 }}>
        Nenhum e-mail nesta pasta.
      </Typography>
    );
  }

  return (
    <List disablePadding>
      {messages.map((m) => {
        const unread = Boolean(m.unread);
        const active = selectedId === m.id;
        return (
          <ListItemButton
            key={m.id}
            selected={active}
            onClick={() => onSelect(m)}
            sx={{
              alignItems: 'flex-start',
              gap: 1.25,
              py: 1.4,
              px: 1.5,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: unread ? 'rgba(25,118,210,0.06)' : 'transparent',
            }}
          >
            <Avatar
              sx={{
                width: 36,
                height: 36,
                mt: 0.25,
                bgcolor: unread ? 'primary.main' : 'grey.400',
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              {senderInitial(m.from)}
            </Avatar>
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                {unread && (
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: 'primary.main',
                      flexShrink: 0,
                    }}
                  />
                )}
                <Typography
                  variant="body2"
                  noWrap
                  fontWeight={unread ? 800 : 600}
                  sx={{ flex: 1, color: 'text.primary' }}
                >
                  {senderName(m.from)}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                  {formatWhen(m.internalDate, m.date)}
                </Typography>
              </Stack>
              <Typography variant="body2" noWrap fontWeight={unread ? 700 : 500} sx={{ mt: 0.15 }}>
                {m.subject || '(sem assunto)'}
              </Typography>
              <Typography variant="caption" color="text.secondary" noWrap display="block">
                {m.snippet || ' '}
              </Typography>
            </Box>
          </ListItemButton>
        );
      })}
    </List>
  );
}
